import { HeaderCatalog } from '@/widgets/header/header-catalog/header-catalog';
import { HeaderSearch } from '@/widgets/header/header-search/header-search';
import { HeaderSearchResult } from '@/widgets/header/header-search-result/header-search-result';
import { HeaderMenu } from '@/widgets/header/header-menu/header-menu';

class Header {
	loadedClass = 'header--loaded';
	fixedClass = 'header--fixed';
	hideOnScrollClass = 'site-header-scroll--hide-on-scroll';
	media = matchMedia('(width >= 1000px)');
	/** только узкие экраны < $mobile (450px), планшет и десктоп без изменений */
	mobileOnlyMedia = matchMedia('(width < 450px)');

	constructor(element) {
		if (!element) return;
		this.element = element;
		this.headerRoot = this.element.querySelector('.header');
		if (!this.headerRoot) return;

		this.top = this.headerRoot.querySelector('.header__top');
		this.announcement = this.element.querySelector('.header-announcement');
		this.main = this.headerRoot.querySelector('.header__main');

		this.lastScrollY = window.pageYOffset || document.documentElement.scrollTop;

		this.handleScroll = this.handleScroll.bind(this);
		this.handleMobileOnlyChange = this.handleMobileOnlyChange.bind(this);

		this.init();
	}

	setHeight = () => {
		requestAnimationFrame(() => {
			const bottom = (this.top?.offsetHeight || 0) + (this.main?.offsetHeight || 0);
			const announcementHeaderHeight = (this.announcement?.offsetHeight || 0) + bottom;
			this.headerRoot.style.setProperty('height', `${bottom}px`);
			this.headerRoot.style.setProperty('--header-height', `${announcementHeaderHeight}px`);
			document.documentElement.style.setProperty('--site-header-offset', `${announcementHeaderHeight}px`);
		});
	};

	setFixPosition = () => {
		this.fixPos = this.top?.offsetHeight || 0;
	};

	setFixed = () => {
		if (this.mobileOnlyMedia.matches) {
			this.headerRoot.classList.remove(this.fixedClass);
			this.headerRoot.style.removeProperty('--top');
			return;
		}
		if (window.pageYOffset >= this.fixPos) {
			this.headerRoot.classList.add(this.fixedClass);
			this.headerRoot.style.setProperty('--top', `${this.announcement?.offsetHeight || 0}px`);
		} else this.headerRoot.classList.remove(this.fixedClass);
	};

	updateHideOnScroll = () => {
		if (!this.mobileOnlyMedia.matches) {
			this.element.classList.remove(this.hideOnScrollClass);
			return;
		}

		const y = window.pageYOffset || document.documentElement.scrollTop;
		const delta = y - this.lastScrollY;
		const threshold = 6;

		if (y < 40) {
			this.element.classList.remove(this.hideOnScrollClass);
		} else if (delta > threshold) {
			this.element.classList.add(this.hideOnScrollClass);
		} else if (delta < -threshold) {
			this.element.classList.remove(this.hideOnScrollClass);
		}

		this.lastScrollY = y;
	};

	handleScroll = () => {
		this.setFixed();
		this.updateHideOnScroll();
	};

	resetAll = () => {
		this.headerRoot.style.removeProperty('height');
		this.fixPos = null;
		this.headerRoot.classList.remove(this.fixedClass);
		this.headerRoot.classList.remove(this.loadedClass);
		this.headerRoot.style.removeProperty('--top');
		window.removeEventListener('scroll', this.handleScroll);
		this.element.classList.remove(this.hideOnScrollClass);
		document.documentElement.style.removeProperty('--site-header-offset');
	};

	setAll = () => {
		this.setHeight();
		this.setFixPosition();
		this.setFixed();
		this.headerRoot.classList.add(this.loadedClass);
		window.addEventListener('scroll', this.handleScroll);
		this.lastScrollY = window.pageYOffset || document.documentElement.scrollTop;
	};

	handleMediaChange = () => {
		this.resetAll();
		this.setAll();
	};

	handleMobileOnlyChange = () => {
		if (!this.mobileOnlyMedia.matches) {
			this.element.classList.remove(this.hideOnScrollClass);
		}
		this.lastScrollY = window.pageYOffset || document.documentElement.scrollTop;
		this.setFixed();
	};

	handleReadyStateChange = ({ target }) => {
		if (target.readyState !== 'complete') return;
		this.setAll();
		document.removeEventListener('readystatechange', this.handleReadyStateChange);
	};

	init = () => {
		this.media.addEventListener('change', this.handleMediaChange);
		this.mobileOnlyMedia.addEventListener('change', this.handleMobileOnlyChange);
		if (document.readyState === 'complete') this.setAll();
		else document.addEventListener('readystatechange', this.handleReadyStateChange);
	};
}

export const header = () => {
	window.app.header = new Header(document.querySelector('.js-header'));
	new HeaderCatalog(document.querySelector('.js-header-catalog'));
	new HeaderSearch(document.querySelector('.js-header-search'));
	window.app.headerSearchResult = new HeaderSearchResult(
		document.querySelector('.js-header-search-result'),
	);
	new HeaderMenu(document.querySelector('.js-header-menu'));
};
